<template>
    <div v-loading.fullscreen.lock="state.fullLoading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-card class="box-card">
            <el-page-header content="用户充值" :icon="null" title="充值管理">
                <template #extra>
                    <el-button type="primary" @click="searchFun(1)">查询</el-button>
                    <el-button @click="searchFun(2)">重置</el-button>
                </template>
                <el-form :model="search" label-width="80px" class="demo-ruleForm">
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="用户名:" prop="userName">
                                <el-input v-model="search.userName" placeholder="请输入用户名" @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="手机号:" prop="phone">
                                <el-input v-model="search.phone" type="number" placeholder="请输入手机号"
                                    @keyup.enter="searchFun(1)" />
                            </el-form-item>
                        </el-col>
                        <el-col :span="8"></el-col>
                    </el-row>
                </el-form>
            </el-page-header>
            <el-table :data="tableData" border style="width: 100%" height="calc(100vh - 295px)" row-key="id"
                v-loading="state.tableLoading">
                <el-table-column prop="userName" label="用户名" min-width="200px" />
                <el-table-column prop="phone" label="手机号码" min-width="130px" />
                <el-table-column prop="email" label="邮箱" min-width="180px" />
                <el-table-column prop="curAmt" label="余额" min-width="150px">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ formatCurrency(scope.row?.curAmt / 100, 2, '.', ',') }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" min-width="180px" />
                <el-table-column fixed="right" label="操作" width="140px">
                    <template #default="scope">
                        <el-button type="primary" @click="handleRecharge(scope.row, 1)" size="small">充值</el-button>
                        <el-button type="danger" @click="handleRecharge(scope.row, 2)" size="small">调减</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total,sizes,prev, pager, next"
                    v-model:current-page="pagination.current" v-model:page-size="pagination.size"
                    :total="pagination.total" :page-sizes="pagination.sizes" :page-size="pagination.size"
                    prev-text="上一页" next-text="下一页" @current-change="intTableData" @size-change="intTableData" />
                <div style="clear: both;"></div>
            </div>
        </el-card>
    </div>
    <el-dialog v-model="recharge.dialogVisible" :title="recharge.formValue.type == 1 ? '用户充值' : '用户余额调减'" width="400">
        <el-form ref="rechargeFormRef" :model="recharge.formValue" :rules="recharge.formRules" label-width="80px"
            status-icon>
            <el-form-item label="充值金额" prop="adjAmt">
                <el-input-number v-model="recharge.formValue.adjAmt"
                    :placeholder="recharge.formValue.type == 1 ? '请输入充值金额（元）' : '请输入调减金额（元）'" :min="0.01" :precision="2"
                    :controls="false" style="width: 100%" />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="recharge.dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="rechargeDialogConfirm">确认</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import { getRechargeListFun, rechargeFun } from "@/api/recharge"
import { formatCurrency } from "@/util/formValidator";

// 高级查询信息
const search = reactive({
    userName: "",
    phone: "",
    recommenderId: "",
})
// 通用信息
const state = reactive({
    fullLoading: false,
    tableLoading: false,
});
// 充值表单信息
const recharge = reactive({
    dialogVisible: false,
    formValue: {
        adjAmt: null,
        id: null,
        type: 1,// 1充值 2调减
    },
    formRules: {
        adjAmt: [{ required: true, message: '请输入金额', trigger: 'blur' }],
    },
})

const tableData = ref([]);
const pagination = reactive({
    current: 1,
    size: 20,
    total: 0,
    sizes: [20, 50, 100]
});

const rechargeFormRef = ref();

// 充值
const handleRecharge = (row, type) => {
    recharge.formValue.id = row.id;
    recharge.formValue.type = type;
    recharge.formValue.adjAmt = null;
    recharge.dialogVisible = true;
}
// 充值确认
const rechargeDialogConfirm = () => {
    // 1.校验表单
    rechargeFormRef.value.validate((valid) => {
        if (valid) {
            state.fullLoading = true;
            const params = {
                adjAmt: recharge.formValue.adjAmt * 100,
                userId: recharge.formValue.id,
            }
            rechargeFun(params, recharge.formValue.type).then((res) => {
                recharge.dialogVisible = false;
                intTableData();
            }).finally(() => {
                state.fullLoading = false;
            });
        }
    })
}
// 查询 1查询 2重置
const searchFun = (type) => {
    if (type == 2) {
        search.userName = '';
        search.phone = '';
    }
    pagination.current = 1;
    intTableData();
}
// 获取表格数据
const intTableData = async () => {
    state.tableLoading = true;
    const params = {
        keys: ['current', 'size'],
        formValue: {
            current: pagination.current,
            size: pagination.size,
        }
    }
    for (let key in search) {
        if (search[key]) {
            params.keys.push(key);
            params.formValue[key] = search[key];
        }
    }
    getRechargeListFun(params).then((res) => {
        tableData.value = res.data.records;
        pagination.total = res.data.total;
    }).finally(() => {
        state.tableLoading = false;
    });
}
onMounted(() => {
    intTableData();
});
</script>
<style lang="scss" scoped>
.demo-ruleForm {
    margin-top: 15px;
}

.pagination-box {
    text-align: right;
}

.el-pagination {
    margin-top: 15px;
    float: right;
}

::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
}

::v-deep input[type='number'] {
    -moz-appearance: textfield !important;
}

::v-deep .el-input-number .el-input__inner {
    text-align: left;
}
</style>